var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var updateMessages = function (state, action) {
    return __assign(__assign({}, state), { messages: action.payload });
};
export var updateHasNew = function (state, action) {
    return __assign(__assign({}, state), { hasNew: action.payload });
};
export var newMessage = function (state, action) {
    var newMessage = action.payload;
    var isNew = newMessage.author !== state.identity;
    var hasCustomerAddedNewMessage = !!state.members
        .filter(function (mem) { return mem.type === 'customer'; })
        .find(function (mem) { return mem.identity === newMessage.authorIdentity; });
    return __assign(__assign({}, state), { hasNew: isNew, hasCustomerAddedNewMessage: hasCustomerAddedNewMessage, messages: __spreadArray(__spreadArray([], (state.messages || []), true), [action.payload], false) });
};
export var updateHasMore = function (state, action) {
    return __assign(__assign({}, state), { hasMore: action.payload });
};
export var updateFetchMoreMethod = function (state, action) {
    return __assign(__assign({}, state), { fetchMore: action.payload });
};
export var updateFetchedMoreMessages = function (state, action) {
    return __assign(__assign({}, state), { fetchingMore: false, messages: __spreadArray(__spreadArray([], action.payload, true), state.messages, true) });
};
export var updateMarkReadMethod = function (state, action) {
    return __assign(__assign({}, state), { setMessagesRead: action.payload });
};
export var resetHasCustomerAddedNewMessage = function (state) { return (__assign(__assign({}, state), { hasCustomerAddedNewMessage: false })); };
//# sourceMappingURL=MessageReducers.js.map